module.exports = __webpack_public_path__ + "img/edit_history_icon.a02562ff.svg";